<template>
  <div class="visitor-record-item" :class="[userType == 'teacher' ? 'teacher' : '']" @click="clickEvt">
    <div class="left">
      <span class="type">{{
        (detail.appointmentDictionaryName || "").substring(0, 1)
      }}</span>
    </div>
    <div class="right">
      <div class="title">{{ detail.appointmentDictionaryName }}</div>
      <div class="name" v-if="userType == 'teacher'">
        访客姓名：{{ detail.personName }}
      </div>
      <div class="name" v-else>
        拜访对象：{{ detail.intervieweePersonName }}
      </div>
      <div class="time">预约拜访时间：{{ detail.applicationDate }}</div>
      <div
        class="status"
        :class="[recordTypeLabels[detail.actualDirection].className]"
      >
        {{ recordTypeLabels[detail.actualDirection].label }}
      </div>
    </div>
  </div>
</template>

<script>
import { ref, toRefs } from "vue"
export default {
  name: "VisitorRecordItem",
  props: {
    userType: {
      type: String,
      default: "",
    },
    detail: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  setup(props, { emit }) {
    let { detail } = toRefs(props)
    const recordTypeLabels = ref({
      0: {
        label: "待审批",
        className: "unApproval",
      },
      1: {
        label: "已拒绝",
        className: "refused",
      },
      2: {
        label: "未拜访",
        className: "unvisited",
      },
      4: {
        label: "已拜访",
        className: "visited",
      },
      5: {
        label: "已过期",
        className: "expired",
      },
      1000: {
        label: "",
        className: "",
      },
    })
    const clickEvt = () => {
      console.log("clickEvt")
      emit("clickEvt", detail.value)
    }
    return {
      recordTypeLabels,
      clickEvt,
    }
  },
}
</script>

<style lang="less" scoped>
.visitor-record-item {
  display: flex;
  padding: 16px 12px;
  margin: 10px 15px;
  border-radius: 8px;
  background-color: #fff;
  &.teacher{
    margin-top: 0;
  }
  .left {
    .type {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      color: #fff;
      font-size: 20px;
      background-color: #4174fd;
    }
  }
  .right {
    position: relative;
    padding: 0 12px;
    flex: 1;
    .title {
      color: #333;
      font-size: 17px;
      font-weight: 500;
      margin-bottom: 8px;
    }
    .name,
    .time {
      color: #999;
      font-size: 13px;
      font-weight: 400;
      margin: 4px auto;
    }
    .status {
      position: absolute;
      right: -12px;
      top: 0;
      height: 20px;
      line-height: 20px;
      padding: 0px 8px;
      color: #999;
      font-size: 13px;
      font-weight: 400;
      background-color: #ebebeb;
      border-radius: 10px 0 0 10px;

      &.expired {
        color: rgba(153, 153, 153, 1);
        background-color: rgba(153, 153, 153, 0.2);
      }
      &.unvisited {
        color: rgba(66, 117, 253, 1);
        background-color: rgba(66, 117, 253, 0.2);
      }
      &.unApproval {
        color: rgba(255, 137, 72, 1);
        background-color: rgba(255, 137, 72, 0.2);
      }
      &.visited {
        color: rgba(60, 194, 81, 1);
        background-color: rgba(60, 194, 81, 0.2);
      }
      &.refused {
        color: rgba(254, 79, 84, 1);
        background-color: rgba(254, 79, 84, 0.2);
      }
    }
  }
}
</style>
